module.exports = __webpack_public_path__ + "static/media/calendario.62f9a4fe.jpg";